<script lang="ts">
      import HeroWithScrollStatic from '../hero/HeroWithScroll.svelte'
      import FeedBlock from '../feed/FeedBlock.svelte'
      import LexicalBlock from '../lexical/LexicalBlock.svelte'
      import ImageBlock from '../gallery/ImageBlock.svelte'
      import LogoBlock from '../logo/LogoBlock.svelte'
      import ContactBlock from '../contacts/ContactBlock.svelte'
      import MosaicBlock from '../gallery/MosaicBlock.svelte'
      import QuoteBlock from '../quote/QuoteBlock.svelte'
      import CarouselBlock from '../gallery/CarouselBlock.svelte'
      import GridBlock from '../grid/GridBlock.svelte'
      import CatalogueBlock from '../program/CatalogueBlock.svelte'
      import ProgramBlock from '../program/ProgramBlock.svelte'

      let { block } = $props()
</script>

{#if block.blockType == 'heroBlock'}
      <HeroWithScrollStatic {block}></HeroWithScrollStatic>
{:else if block.blockType == 'categoryBlock'}
      <FeedBlock {block}></FeedBlock>
{:else if block.blockType == 'lexicalBlock'}
      <LexicalBlock {block}></LexicalBlock>
{:else if block.blockType == 'imageBlock'}
      <ImageBlock {block}></ImageBlock>
{:else if block.blockType == 'logoBlock'}
      <LogoBlock {block}></LogoBlock>
{:else if block.blockType == 'contactBlock'}
      <ContactBlock {block}></ContactBlock>
{:else if block.blockType == 'mosaicBlock'}
      <MosaicBlock {block}></MosaicBlock>
{:else if block.blockType == 'quoteBlock'}
      <QuoteBlock {block}></QuoteBlock>
{:else if block.blockType == 'carouselBlock'}
      <CarouselBlock {block}></CarouselBlock>
{:else if block.blockType == 'categoryGridBlock'}
      <GridBlock {block}></GridBlock>
{:else if block.blockType == 'catalogueBlock'}
      <CatalogueBlock items={block.populate?.map((i) => i.value).filter((i) => !!i) ?? []}></CatalogueBlock>
{:else if block.blockType == 'programBlock'}
      <ProgramBlock items={block.populate?.map((i) => i.value).filter((i) => !!i) ?? []}></ProgramBlock>
{/if}
